import React from 'react'
import { CountContainer } from './style'

export const CustomNotification = ({ count, style }) => {
    return (
        <CountContainer style={style}>
            {count}
        </CountContainer>
    )
}